import React, { useEffect, useState, useMemo, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, IconButton, useTheme, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { tokens } from '../../../theme';
import Header from "../../../components/Header";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import useMediaQuery from '@mui/material/useMediaQuery';
import { deleteCommercialMarketing, getCommercialMarketing } from '../../../redux/slice/Commercialmarketing.slice';
import { deleteLiasoning } from '../../../redux/slice/liasoning.slice';
import { Image_URL } from '../../../utils/baseURL';
import { format } from 'date-fns';

const ListMarket = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const colors = tokens(theme.palette.mode);
    const [open, setOpen] = useState(false);
    const [update, setUpdate] = useState(null);
    const [openView, setOpenView] = React.useState(false);
    const [viewData, setViewData] = useState(null);
    const [dealer, setDealar] = useState('');
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [deleteMarketing, setDeleteMarketing] = useState(null);
    const [deleteLiasoningId, setDeleteLiasoningId] = useState(null);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const downloadRef = React.useRef(null);
    const Alluser = useSelector(state => state.users.users);
    const CommercialMarket = useSelector(state => state.comMarketing.Marketing);
    const navigate = useNavigate();
    const productData = useSelector(state => state.products.products)
    const isMobile = useMediaQuery('(max-width:500px)');
    const imgUrl = Image_URL;
    const UserName = useSelector((state) => state.dashboard.user);
    console.log(UserName);


    useEffect(() => {
        dispatch(getCommercialMarketing());
    }, [theme]);

    const MarketDataGrid = memo(({ data, columns }) => {
        const validData = data.filter(row => row && (row._id || row.fillNo));
        return (
            <DataGrid
                rows={validData}
                columns={columns}
                components={{ Toolbar: GridToolbar }}
                pageSize={5}
                rowsPerPageOptions={[5, 10]}
                getRowId={(row) => row?._id || row.fillNo}
                getRowClassName={(params) => {
                    const liasoningItem = params.row.liasoningData?.[0];
                    return liasoningItem && liasoningItem.status === "Enabled" ? 'disabled-row' : '';
                }}
                density="compact"
                autoHeight
                sx={{
                    "@media print": {
                        "& .MuiDataGrid-toolbarContainer": {
                            display: "none !important"
                        },
                        "& .MuiDataGrid-root": {
                            color: "black !important",
                        },
                        "& .MuiDataGrid-cell": {
                            color: "black !important",
                        },
                        "& .MuiDataGrid-columnHeaders": {
                            color: "black !important",
                        },
                        "& .MuiDataGrid-footerContainer": {
                            color: "black !important",
                        },
                        "& .css-7ms3qr-MuiTablePagination-displayedRows": {
                            color: "black !important",
                        },
                    },
                }}
                initialState={{
                    sorting: {
                        sortModel: [
                            { field: "fillNo", sort: "desc" }  // 👈 default sorting here
                        ],
                    },
                }}
            />
        );
    });

    console.log(dealer);


    const allUsers = useSelector(state => state.users.users);
    useEffect(() => {
        if (allUsers && viewData) {
            const dealerName = allUsers.find(user => user._id === viewData.Dealer);
            setDealar(dealerName);
        }
    }, [allUsers, viewData])

    const handleClickOpenView = () => {
        setOpenView(true);
    };

    const handleCloseView = () => {
        setOpenView(false);
    };

    const handleDelete = (id, liasoningId) => {
        setDeleteMarketing(id);
        setDeleteLiasoningId(liasoningId);
        setDeleteConfirmOpen(true);
    };

    const confirmDelete = () => {
        if (deleteMarketing) {
            dispatch(deleteCommercialMarketing(deleteMarketing));
            dispatch(deleteLiasoning(deleteLiasoningId));
            setDeleteConfirmOpen(false);
            setDeleteMarketing(null);
        }
    }
    const cancelDelete = () => {
        setDeleteConfirmOpen(false);
        setDeleteMarketing(null);
    }


    const handleEdit = (data) => {
        console.log("handleEdithandleEdit",data);
        
        setOpen(true);
        setUpdate(data);
        navigate('/admin/add-market', { state: { id: data._id, dealerName: data?.userData[0]?.name, dealerset: "", state: data.state, 
            district: data.district,  ConsumerNumberL: data.ConsumerNumber} });
    };
    const handleView = (data) => {
        handleClickOpenView();
        setViewData(data)
    }

    const getFQButtonText = (fillNo) => {
        const liasoningItem = fillNo;
        if (liasoningItem) {
            if (!liasoningItem.fileNo) {
                return "Application Pending";
            }
            if (liasoningItem.Query4) {
                return "Subcidy Received Status";
            }
            if (liasoningItem.Query3) {
                const claimDate = new Date(liasoningItem.CheckBox4date);
                const currentDate = new Date();
                const differenceInDays = Math.floor((currentDate - claimDate) / (1000 * 60 * 60 * 24));

                if (differenceInDays >= 25) {
                    return "Subcidy Received Status";
                } else {
                    return "Subcidy Claim Process";
                }
            }
            if (liasoningItem.Query2) {
                return "Net Meter Install";
            }
            if (liasoningItem.Query1) {
                return "Net Meter Document Qurier";
            }

            if (liasoningItem.SerialNumber) {
                return "Net Meter Document Upload";
            }

            if (liasoningItem.AmountL) {
                return "Site Details";
            }

            if (liasoningItem.FQPayment) {
                return "FQ Paid";
            }
            const submissionDate = new Date(liasoningItem.createdAt);
            const currentDate = new Date();
            const differenceInDays = Math.floor((currentDate - submissionDate) / (1000 * 60 * 60 * 24));

            if (differenceInDays < 10) {
                return "Application Submitted";
            } else {
                return "FQ Status";
            }
        }
        return "Application Pending";
    };



    const [imageViewOpen, setImageViewOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const handleImageView = (imagePath) => {
        setSelectedImage(`${imgUrl}/${imagePath}`);
        setImageViewOpen(true);
    };

    const handleCloseImageView = () => {
        setImageViewOpen(false);
        setSelectedImage(null);
    };



    const columns = useMemo(() => [
        { field: 'fillNo', headerName: 'File No', width: 120 },
        {
            field: 'ConsumerName || ContactPersonName', headerName: 'Name', width: 280,
            filterable: true,
            valueGetter: (params) => {
                const consumerName = params.row?.ConsumerName;
                const contactPersonName = params.row?.ContactPersonName;
                const nameToShow = consumerName || contactPersonName;
                return nameToShow || params.row?.category_id?.name;
            },
            renderCell: (params) => {
                const consumerName = params.row?.ConsumerName;
                const contactPersonName = params.row?.ContactPersonName;
                const nameToShow = consumerName || contactPersonName;
                return nameToShow || params.row?.category_id?.name;
            }
        },
        {
            field: 'PhoneNumber', headerName: 'Contact No', width: 140,
        },
        {
            field: 'City_Village', headerName: 'City', width: 150,
        },
        {
            field: 'SystemSizeKw', headerName: 'System Size', width: 120,
        },

        {
            field: 'ProductName', headerName: 'Solar Module', width: 210,
            valueGetter: (params) => {
                return params.row?.productData[0]?.productName;
            }
        },
        {
            field: 'InverterName', headerName: 'Solar Inverter', width: 190,
            valueGetter: (params) => {
                return params.row?.inverterData[0]?.productName;
            }
        },
        {
            field: 'TotalAmount', headerName: 'Total Amount', width: 160,
            valueGetter: (params) => {
                return params.row.TotalAmount;
            }
        },
        {
            field: 'userId', headerName: 'Dealer', width: 150,
            valueGetter: (params) => {
                return params.row?.userData[0]?.name;
            }
        },
        {
            field: 'ConsumerNumber', headerName: 'Consumer No', width: 130,
        },

        {
            field: 'MarketingType', headerName: 'Type of Customer', width: 140,
            renderCell: (params) => {
                return params.row.name;
            }
        },
        {
            field: 'status', headerName: 'Status', width: 200,
            filterable: true,
            valueGetter: (params) => {
                return params.row.liasoningData?.[0]?.applicationStatus || "N/A"
            },
            renderCell: (params) => {
                return params.row.liasoningData?.[0]?.applicationStatus || "N/A"
            }
        },
        {
            field: 'Action',
            headerName: 'Action',
            width: 130,
            renderCell: (params) => {
                const liasoningItem = params.row.liasoningData?.[0];
                const isDisabled = liasoningItem && liasoningItem.status === "Enabled";
                const opacity = liasoningItem?.fileNo
                return (
                    <>
                        <IconButton aria-label="view" onClick={() => handleView(params.row)} disabled={isDisabled} >
                            <RemoveRedEyeIcon />
                        </IconButton>
                        <IconButton aria-label="edit" onClick={() => handleEdit(params.row)} disabled={isDisabled}>
                            <EditIcon />
                        </IconButton>
                        <IconButton aria-label="delete" onClick={() => handleDelete(params.row._id, liasoningItem?._id)} disabled={isDisabled} style={{ opacity: opacity ? 0.5 : 1, pointerEvents: opacity ? "none" : "auto" }}>
                            <DeleteIcon />
                        </IconButton>
                    </>
                );
            }
        },
    ], [productData]);


    const [openViewImage, setOpenViewImage] = React.useState(false);
    const [viewImage, setViewImage] = useState(null);

    const [values, setValues] = useState({});
    const [dealarData, setDealarData] = useState({});

    const handleViewImage = (imageType) => {
        let imageUrl;
        const baseUrl = { imgUrl };

        if (imageType === 'adharCard') {
            imageUrl = `${baseUrl}${viewData?.adharCard}`;
        } else if (imageType === 'lightBill') {
            imageUrl = `${baseUrl}${viewData?.lightBill}`;
        } else if (imageType === 'veraBill') {
            imageUrl = `${baseUrl}${viewData?.veraBill}`;
        }

        setViewImage(imageUrl);
        setOpenViewImage(true);
    }
    const handleCloseViewImage = () => {
        setOpenViewImage(false);
    };
    const handleDownload = async () => {

        if (viewImage) {
            try {
                let imageUrl;
                if (viewData && viewData._id) {
                    if (viewImage.includes("4000")) {
                        const proxyUrl = `/api/proxy-image?url=${encodeURIComponent(viewImage)}`;
                        imageUrl = proxyUrl;
                    } else {
                        imageUrl = viewImage;
                    }
                } else {
                    imageUrl = viewImage;
                }
                const response = await fetch(imageUrl);
                if (response.ok) {
                    const blob = await response.blob();
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = 'downloaded-image.png';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                } else {
                    console.error('Failed to download image');
                }
            } catch (error) {
                console.error('Error in download process:', error);
            }
        } else {

        }
    };
    const handleAddMarketing = () => {
        navigate('/admin/add-market', { state: { adminId: UserName._id, adminName: UserName.name } });
    }
    return (
        <Box m="2px">
            <Header
                title="MARKETING"
                subtitle="Manage Your Marketing Here"
            />
            <Box display="flex" justifyContent="flex-end" mb={2}>
                <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleAddMarketing}>
                    Add Marketing
                </Button>
            </Box>

            <Box
                height="75vh"
                sx={useMemo(() => ({
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .disabled-row": {
                        pointerEvents: "none",
                        "& .MuiDataGrid-cell": {
                            color: `${colors.grey[500]} !important`,
                        },
                    },

                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[700],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[700],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                        color: `${colors.grey[100]} !important`,
                        fontSize: "13px !important"
                    },
                }), [colors])}
            >
                <MarketDataGrid data={CommercialMarket} columns={columns} />
            </Box>
            <Dialog
                fullScreen={fullScreen}
                open={openView}
                onClose={handleCloseView}
                aria-labelledby="responsive-dialog-title"
                maxWidth={"sm"}
                fullWidth
            >
                <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: theme.palette.background.purple, textAlign: 'center', fontWeight: 'bold' }}>
                    {viewData?.MarketingType === 'Residential'
                        ? "Residential Market Details"
                        : "Commercial Market Details"}
                </DialogTitle>
                <DialogContent style={{ backgroundColor: theme.palette.background.purple }}>
                    <DialogContentText>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2px' }}>
                            {viewData?.MarketingType === 'Residential' ? (
                                <>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Fill No:</strong> {viewData?.fillNo}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Marketing Type:</strong> {viewData?.MarketingType}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Date:</strong>  {viewData?.Date ? format(new Date(viewData.Date), 'dd-MM-yyyy') : ''}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Recd Payment As a loan:</strong> {viewData?.payment_as_loan}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Type of loan:</strong> {viewData?.type_loan}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Warehouse:</strong> {viewData?.wareHouseData?.[0]?.wareHouseName}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Consumer Name:</strong> {viewData?.ConsumerName}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Phone Number:</strong> {viewData?.PhoneNumber}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Consumer Number:</strong> {viewData?.ConsumerNumber}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>State:</strong> {viewData?.state}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>District:</strong> {viewData?.district}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>City Village:</strong> {viewData?.City_Village}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Address:</strong> {viewData?.Address}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Pincode:</strong> {viewData?.Pincode}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Latitude:</strong> {viewData?.Latitude}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Longitude:</strong> {viewData?.Longitude}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Solar Module:</strong>{viewData?.productData?.[0]?.productName}</p>

                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Solar Module Make:</strong>{viewData?.SolarModuleMake}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Solar Module Wp:</strong>{viewData?.SolarModuleWp}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Solar Module Nos:</strong>{viewData?.SolarModuleNos}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Solar Inverter:</strong>{viewData?.inverterData?.[0]?.productName}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Solar Inverter Make:</strong>{viewData?.InverterModuleMake}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Solar Inverter Size:</strong>{viewData?.InverterModuleWp}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>System Size:</strong>{viewData?.SystemSizeKw}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Primary Amount:</strong>{viewData?.PrimaryAmount}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Cash Amount:</strong>{viewData?.CashAmount}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Total Amount:</strong>{viewData?.TotalAmount}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Dealer:</strong> {viewData?.userData?.[0]?.name}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Dealer Amount:</strong> {viewData.dealerData?.[0]?.amount}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Commission/perKW:</strong>{viewData?.CommissionPerKW}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Total Commission:</strong>{viewData?.TotalCommission}</p>

                                    {viewData?.MultipleDetails && viewData?.MultipleDetails.length > 0 && viewData?.MultipleDetails.map((detail, index) => (
                                        <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px', display: 'flex', alignItems: 'center' }}>
                                            <strong>{detail?.inputField} : </strong>
                                            <div style={{ maxWidth: '100%', maxHeight: '80vh' }} >
                                                {detail?.dealerImage.endsWith('.pdf') ? (
                                                    <iframe
                                                        src={`${imgUrl}/${detail?.dealerImage}`}
                                                        style={{ width: '50px', height: '50px', border: 'none', marginLeft: '20px' }}
                                                        title="PDF Preview"
                                                    />
                                                ) : (
                                                    <img
                                                        style={{ width: '50px', height: '50px', objectFit: 'cover', marginLeft: '20px' }}
                                                        src={`${imgUrl}/${detail?.dealerImage}`}
                                                        alt={detail?.inputField}
                                                    />
                                                )}
                                            </div>
                                            <IconButton onClick={() => handleImageView(detail?.dealerImage)}>
                                                <RemoveRedEyeIcon />
                                            </IconButton>
                                        </p>
                                    ))}
                                </>
                            ) : (
                                <>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Fill No: </strong> {viewData?.fillNo}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Marketing Type: </strong> {viewData?.MarketingType}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Date: </strong>  {viewData?.Date ? format(new Date(viewData.Date), 'dd-MM-yyyy') : ''}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Warehouse: </strong> {viewData?.wareHouseData?.[0]?.wareHouseName}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Consumer Name: </strong> {viewData?.ConsumerName}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Contact Person Name: </strong> {viewData?.ContactPersonName}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Phone Number: </strong> {viewData?.PhoneNumber}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>State: </strong> {viewData?.state}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>District: </strong> {viewData?.district}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Address: </strong> {viewData?.Address}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>City Village: </strong> {viewData?.City_Village}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Pincode: </strong> {viewData?.Pincode}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Latitude: </strong> {viewData?.Latitude}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Longitude: </strong> {viewData?.Longitude}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Amount: </strong> {viewData?.Amount}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>GST: </strong> {viewData?.Amount}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Total Amount: </strong> {viewData?.TotalAmount}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>GST Number: </strong> {viewData?.GSTNumber}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Pan Number: </strong> {viewData?.PanNumber}</p>

                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>MSME/Udyam REGISTRATION: </strong> {viewData?.MSME_UdyamREGISTRATION}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Solar Module: </strong>{viewData?.productData?.[0]?.productName}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Solar Module Make:</strong>{viewData?.SolarModuleMake}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Solar Module Wp:</strong>{viewData?.SolarModuleWp}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Solar Module Nos:</strong>{viewData?.SolarModuleNos}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Solar Inverter: </strong>{viewData?.inverterData?.[0]?.productName}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Solar Inverter Make: </strong>{viewData?.InverterModuleMake}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Solar Inverter Size: </strong>{viewData?.InverterModuleWp}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>System Size: </strong>{viewData?.SystemSizeKw}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Consumer Number: </strong> {viewData?.ConsumerNumber}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Connection Load: </strong> {viewData?.ConnectionLoad}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Tarrif: </strong> {viewData?.Tarrif}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Average Monthly Bill: </strong> {viewData?.AverageMonthlyBill}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Phase: </strong> {viewData?.Phase}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Dealer: </strong> {viewData?.userData?.[0]?.name}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Dealer Amount: </strong> {viewData?.dealerData?.[0]?.amount}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Commission/perKW: </strong>{viewData?.CommissionPerKW}</p>
                                    <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Total Commission: </strong>{viewData?.TotalCommission}</p>

                                    {viewData?.MultipleDetails && viewData?.MultipleDetails.length > 0 && viewData?.MultipleDetails.map((detail, index) => (
                                        <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px', display: 'flex', alignItems: 'center' }}>
                                            <strong>{detail?.inputField} : </strong>
                                            <div style={{ maxWidth: '100%', maxHeight: '80vh' }} >
                                                {detail?.dealerImage.endsWith('.pdf') ? (
                                                    <iframe
                                                        src={`${imgUrl}/${detail?.dealerImage}`}
                                                        style={{ width: '50px', height: '50px', border: 'none', marginLeft: '20px' }}
                                                        title="PDF Preview"
                                                    />
                                                ) : (
                                                    <img
                                                        style={{ width: '50px', height: '50px', objectFit: 'cover', marginLeft: '20px' }}
                                                        src={`${imgUrl}/${detail?.dealerImage}`}
                                                        alt={detail?.inputField}
                                                    />
                                                )}
                                            </div>
                                            <IconButton onClick={() => handleImageView(detail?.dealerImage)}>
                                                <RemoveRedEyeIcon />
                                            </IconButton>
                                        </p>
                                    ))}
                                </>
                            )}
                        </div>

                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ backgroundColor: theme.palette.background.purple }}>
                    <Button autoFocus onClick={handleCloseView} style={{ color: theme.palette.text.primary }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog >
            <Dialog open={deleteConfirmOpen} onClose={cancelDelete}>
                <DialogContent>
                    Are you sure you want to delete this Marketing?
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancelDelete} style={{ color: theme.palette.text.primary }}>No</Button>
                    <Button onClick={confirmDelete} style={{ color: theme.palette.text.primary }}>Yes</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={imageViewOpen}
                onClose={handleCloseImageView}
                maxWidth="md"
                fullWidth
            >
                <DialogContent>
                    {selectedImage ? (
                        <div style={{ textAlign: 'center' }} >
                            {selectedImage.endsWith('.pdf') ? (
                                <iframe
                                    src={selectedImage}
                                    style={{ width: '800px', height: '80vh', border: 'none', textAlign: 'center' }}
                                    title="PDF Preview"
                                />
                            ) : (
                                <img
                                    src={selectedImage}
                                    alt="Uploaded Image"
                                    style={{ width: '500px', height: 'auto', textAlign: 'center' }}
                                    ref={downloadRef}
                                />
                            )}
                        </div>
                    ) : (
                        <p>No image to display</p>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseImageView} sx={{ color: theme.palette.text.primary }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Box >
    );
};

export default ListMarket;